import { render, staticRenderFns } from "./ElementReveal.vue?vue&type=template&id=4b73d2ac&"
import script from "./ElementReveal.vue?vue&type=script&lang=ts&"
export * from "./ElementReveal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports